/**
 * @fileoverview Names of sidebar panels, where other copy has to refer to them.
 *
 * Four warnings told people "You can still access your prior optimization run
 * using the 'Previous Trials' selection panel." No panel has ever been called
 * that. It is labelled "Saved Runs" (was "Saved Results"), so someone who read
 * the message and went looking found nothing — the instruction could not be
 * followed at all, which is worse than an inconsistent word.
 *
 * Nothing kept the two in step, because one is a heading in a component and the
 * others are strings in a reducer. They are the same constant now, so a rename
 * moves both and a message cannot name a panel that does not exist.
 */

/** The signed-in list of saved optimization runs (ResultsSummaryListItems). */
export const SAVED_RUNS_PANEL = 'Saved Runs';

/** Its sibling, the list of saved scenarios (SavedScenarioListItems). */
export const SAVED_SCENARIOS_PANEL = 'Saved Scenarios';
